import { isArray } from 'lodash';
import Swiper, { Navigation, EffectFade, Thumbs } from 'swiper';

Swiper.use([Navigation, EffectFade, Thumbs]);

const servicesCarouselInit = () => {
    const swiperThumbs = new Swiper('.swiper-services-carousel-thumbs', {
        init: false,
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        centerInsufficientSlides: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        threshold: 10,
        breakpoints: { 1440: { spaceBetween: 96 } }
    });

    const swiperMain = new Swiper('.swiper-services-carousel-main', {
        init: false,
        speed: 400,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        grabCursor: true,
        thumbs: { swiper: swiperThumbs },
        navigation: {
            nextEl: '.swiper-services-carousel-button-next',
            prevEl: '.swiper-services-carousel-button-prev'
        }
    });

    if (isArray(swiperThumbs)) {
        swiperThumbs.forEach(s => s.init());
    } else {
        swiperThumbs.init();
    }

    if (isArray(swiperMain)) {
        swiperMain.forEach(s => s.init());
    } else {
        swiperMain.init();
    }
};

document.addEventListener('DOMContentLoaded', servicesCarouselInit);
